module.exports = __webpack_public_path__ + "static/assets/5af55a5080ec99fdeb28d0dbbf67f841.svg";